var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 46.00 46.00",
    width: 46,
    height: 46,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: " M 23.00 17.58 Q 23.17 17.58 23.23 17.52 Q 30.39 10.33 38.20 2.52 C 40.02 0.70 42.29 -0.47 44.38 1.62 C 46.46 3.70 45.30 5.98 43.48 7.80 Q 35.66 15.60 28.47 22.77 Q 28.41 22.83 28.41 22.99 Q 28.41 23.16 28.47 23.22 Q 35.66 30.39 43.48 38.19 C 45.30 40.01 46.46 42.29 44.38 44.37 C 42.29 46.46 40.01 45.29 38.20 43.47 Q 30.39 35.66 23.23 28.47 Q 23.17 28.41 23.00 28.41 Q 22.83 28.41 22.77 28.47 Q 15.61 35.65 7.80 43.47 C 5.98 45.29 3.71 46.45 1.62 44.37 C -0.46 42.29 0.70 40.01 2.52 38.19 Q 10.34 30.39 17.53 23.22 Q 17.59 23.16 17.59 22.99 Q 17.59 22.83 17.53 22.77 Q 10.34 15.60 2.52 7.80 C 0.70 5.98 -0.46 3.70 1.62 1.62 C 3.71 -0.47 5.99 0.70 7.80 2.52 Q 15.61 10.33 22.77 17.52 Q 22.83 17.58 23.00 17.58 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteClose);
export default __webpack_public_path__ + "static/media/white-close.8d59561d68821ec276b7a0e95d76e19e.svg";
export { ForwardRef as ReactComponent };